
import {Link} from 'react-router-dom'
import { reduxForm , handleSubmit, FieldArray,Field, startSubmit, formValueSelector} from 'redux-form'
import {SVPRFORM} from '../../../constants'
import { Icon, Button as SVAButton, Row, Col, Badge } from 'antd';

const _ = require('lodash')
const React = require('react')


const {connect}  = require("react-redux")


/*

const svsubmit =(values)=>{
    let me = this
  console.log('sv submit callback')
  console.log(values)

}
*/

const renderField = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  const renderFieldDup = ({
    input,
    label,
    type,
    meta: { asyncValidating, touched, error }
  }) => (
    
     
      
      <div className={asyncValidating ? 'async-validating' : ''}>
          {touched && error &&  <input className="sverr form-control" {...input} type={type} placeholder={label} /> }
          {touched && !error &&  <input className="svgreen form-control" {...input} type={type} placeholder={label} /> }
        <input className="form-control" {...input} type={type} placeholder={label} />
        {touched && error && <span className="sv-form-err" >{error}</span>}
      </div>
   
  )
  /*
const renderSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )
  const renderTravelSelectList = ({ input, data }) => (
    <SelectList {...input} onBlur={() => input.onBlur()} data={data} />
  )

  const renderBookingAgentType = ({input, data})=> (
      <SelectList {...input } onBlur={() =>input.onBlur()} data={data} />
  )
*/
let dcountries = [{
    name:'United States Of America',
    value:'usa'

  },{
    name:'France',
    value:'France'
  },{

    name:'China',
    value:'China'
},{
    name:'Mexico',
    value:'Mexico'
  
  }]

let genes = [{
    name:'add_step',
    value:'add_step'

  },{
    name:'multiply_seq_step',
    value:'multiply_seq_step'
  },{

    name:'sq_step',
    value:'sq_step'
},{
    name:'sr_step',
    value:'sr_step'
  
  }]


let svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }


let validate =(formData)=>{
    console.log('sv--valudare fprmData')
      console.log(validate)
        const errors={}
        if(!formData){
            console.log('validate: sv formData null issue')
            return errors
        }
        if(!formData.name){
            errors.name= 'Required'
        }
        if(!formData.fname){
            errors.fname= 'Required'
        }
        if(!formData.lname){
            errors.lname= 'Required'
        }
        if(!formData.email){
            errors.email= 'Required'
        }
        if(!formData.address){
            errors.address= 'Required'
        }
        if(!formData.city){
            errors.city= 'Required'
        }
       
        if(!formData.zipcode){
            errors.zipcode= 'Required'
        }
        if(!formData.country){
            errors.country= 'Required'
        }
        if(!formData.isdcode){
            errors.isdcode= 'Required'
        }
       
        /*
         if(!formData.country){
            errors.country= 'Required'
        }
         if(!formData.state){
            errors.state= 'Required'
        }
        if(!formData.isdcode){
            errors.isdcode= 'Required'
        }
        
        if(!formData.phone){
            errors.phone= 'Required'
        }
        */
       
        return errors
    
    }
    
    let warn= (formData)=>{
        const o = {}
        if(!formData){
            console.log('sv gene null issue')
            return o
        }
        /*
        if(formData.lname <2){
            o.gene ='We expect gene to br more tham 5'
        }
        */
        return o
    }


class PwrresetFormBus extends React.Component{

    constructor(props){
        
        super(props)
        let me = this
       
        this.loadGene = this.loadGene.bind(me)
        this.reloadPageSV = this.reloadPageSV(me)
        this.ddChange = this.ddChange.bind(me) 
        this.cancelPage = this.cancelPage.bind(me) 
       
        this.getAppDetails = this.getAppDetails.bind(me)
       
    }

    ddChange(e){
        
        console.log(e)
        console.log('gene name:' +this.props.gene)

        let o = _.findWhere(genes,{value:e.target.value})
        console.log(o)
        this.props.load({
            id:o.value,
             gene:o.name
        })
        //load geneBus Componnet initialValues and form will reinitalize

    }
    
    reloadPageSV=(cid)=>(e)=>{
        console.log('sv****Got the page reloadPageSV needs customerId')
        console.log(cid)
       // history.back(-1)
       

      // history.push(`/myaccountSV/6/svaddress/-1`)
        

    }

    getAppDetails(paramQSpaceId){
        //for edit we have id make it -1 for create

        let id = -1
        if(paramQSpaceId ){
            id  = parseInt(paramQSpaceId)
        }
        console.log("id* addressr det or cerate ******", id)
       //loadAddressDet(id)
        //this.props.sojDetailsAndImagesSV("mancreek") 
        /*this.props.getSojournDetails("mancreek") */
       
    }
    cancelPage(){
        console.log('cancel page')

    }
 loadGene(e){
        console.log(e)
    }


   
  
    
    
    render(){
        console.log('sv...FEb14  PwrresetFormBus')
        const { handleSubmit, pristine, error,reset, submitting } = this.props
       
        const me = this 
        //me.gene = gene
        let initialValues = this.props.initialValues

        console.log(this.props)
        console.log('svfeb14 det needed for initialValues')
        console.log(det)

        const {det} = this.props
        
        if(det ){
            initialValues = det
        }

        let customerId = 789
        

        return (
            <div>
                    <form  onSubmit={handleSubmit}>
                            <div className="rev-row">
                                <div className="card card--raised with-shadow">
                                    <p className="right-sd-content"> <text> Enter Details Now </text></p>

                                       
                                        <div className="form-group">
                                            <label htmlFor="email"> Email Address</label>
                                            <Field
                                                    id="email"
                                                    name="email"
                                                    type="text"
                                                    placeholder="john123@yahoo.com"
                                                    component={renderField}
                                                    className="form-control"
                                            />
                                        </div>
                                        
                                    </div>
                            </div>

                            <div>
               
       
        
               <button type="submit" className="btn btn-success" disabled={pristine || error || submitting}>
          Save(CreateOrModify)
        </button>  
        <SVAButton style={{fontSize:'12px', padding:'5px', color:'#ffffff', backgroundColor:'#ee2e2ef2'}} type="primary" shape="round"  size="{size}" ><Link to={`/svhome`}> SVHome  </Link></SVAButton>
                                                              
         </div>
                    </form>
            </div>
        )
                    
                    

    }
}



const selector = formValueSelector(SVPRFORM)
/*
let svChange = (values, dispatch, props, valuesPrev)=>{

    console.log('sv form change')
  
    console.log(values)
  
  
  }
  */

const prForm  = reduxForm({
    form:SVPRFORM,
    validate:validate,
   
    warn:warn,
    //onSubmit:svsubmit,
    onChange:svChange,
    enableReinitialize:true,
    keepDirtyOnReinitialize:true

})(PwrresetFormBus)
let PwrresetFormBusCom =connect((state=>{
    const { svpwrresetView} = state
    let plucked = state.movies  
    //let o = {initialValues:plucked.adData }
    let o = {initialValues:svpwrresetView.my_data_pwrreset}
    console.log('sv*******************CrateAddressForm shoul getmy_data_pwrreset start ')
    
    //selector(state, 'id')
    console.log('sv info')
    console.log(o)
    console.log('sv*******************CrateAddressForm shoul getmy_data_pwrreset end ')
    
    return o
   // return plucked.adData
}),{
  
    startSubmit:startSubmit
   
   // loadGeneTemplate:loadGeneTemplate

    
})(prForm)


export default PwrresetFormBusCom
//const PwrresetFormBusCom  =x